__turbopack_context__.v({
  "active": "styles-module-scss-module__aWXbXW__active",
  "author_text": "styles-module-scss-module__aWXbXW__author_text",
  "card_details_section": "styles-module-scss-module__aWXbXW__card_details_section",
  "card_image": "styles-module-scss-module__aWXbXW__card_image",
  "card_link": "styles-module-scss-module__aWXbXW__card_link",
  "card_overlay_section": "styles-module-scss-module__aWXbXW__card_overlay_section",
  "card_padded_section": "styles-module-scss-module__aWXbXW__card_padded_section",
  "card_wrapper": "styles-module-scss-module__aWXbXW__card_wrapper",
  "card_wrapper_section": "styles-module-scss-module__aWXbXW__card_wrapper_section",
  "carousel_cards_container": "styles-module-scss-module__aWXbXW__carousel_cards_container",
  "carousel_container": "styles-module-scss-module__aWXbXW__carousel_container",
  "carousel_header_content": "styles-module-scss-module__aWXbXW__carousel_header_content",
  "carousel_heading": "styles-module-scss-module__aWXbXW__carousel_heading",
  "carousel_heading_section": "styles-module-scss-module__aWXbXW__carousel_heading_section",
  "carousel_sub_header": "styles-module-scss-module__aWXbXW__carousel_sub_header",
  "contentful_wrapper": "styles-module-scss-module__aWXbXW__contentful_wrapper",
  "dot": "styles-module-scss-module__aWXbXW__dot",
  "dots": "styles-module-scss-module__aWXbXW__dots",
  "inner_container": "styles-module-scss-module__aWXbXW__inner_container",
  "link_container": "styles-module-scss-module__aWXbXW__link_container",
  "next_el": "styles-module-scss-module__aWXbXW__next_el",
  "one_slide": "styles-module-scss-module__aWXbXW__one_slide",
  "person_image_section": "styles-module-scss-module__aWXbXW__person_image_section",
  "prev_el": "styles-module-scss-module__aWXbXW__prev_el",
  "quote_text": "styles-module-scss-module__aWXbXW__quote_text",
  "slide_item": "styles-module-scss-module__aWXbXW__slide_item",
  "text_content": "styles-module-scss-module__aWXbXW__text_content",
});
